
// (function () {
//     const SELECTOR = '[data-cart-gift]';
//     const NOTE_MAX = 200;

//     const RECIPIENT_ATTR = 'Ship to recipient';
//     const MODE_ATTR = 'gift_card_mode';
//     const NOTE_PROPERTY = 'Gift Note';

//     let writing = Promise.resolve();

//     function post(url, data) {
//         return fetch(url, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             },
//             body: JSON.stringify(data)
//         }).then(response => {
//             if (!response.ok) {
//                 throw new Error(`Cart request failed: ${response.status}`);
//             }

//             return response.json();
//         });
//     }

//     function refreshCart() {
//         document.dispatchEvent(
//             new CustomEvent('cart:refresh', { bubbles: true })
//         );
//     }

//     function queue(task) {
//         writing = writing
//             .then(task)
//             .catch(error => {
//                 console.error('[Cart Gift]', error);
//             });

//         return writing;
//     }

//     function getCart() {
//         return fetch('/cart.js').then(response => response.json());
//     }


//     function init(root) {
//         if (!root || root.dataset.giftInitialized === 'true') return;

//         root.dataset.giftInitialized = 'true';

//         const recipientToggle = root.querySelector('[data-gift-recipient]');
//         const recipientNote = root.querySelector('[data-gift-recipient-note]');

//         const cardToggle = root.querySelector('[data-gift-card-toggle]');
//         const expand = root.querySelector('[data-gift-expand]');

//         const cards = root.querySelectorAll('[data-gift-card]');
//         const modes = root.querySelectorAll('[data-gift-mode]');

//         const textareaWrap = root.querySelector('[data-gift-textarea]');
//         const textarea = root.querySelector('[data-gift-note]');
//         const counter = root.querySelector('[data-gift-count]');
//         const help = root.querySelector('[data-gift-mode-help]');

//         const feeVariantId = Number(root.dataset.handwritingVariant);

//         let selectedCard = null;
//         let mode = 'blank';


//         function setToggle(toggle, value) {
//             if (toggle) toggle.setAttribute('aria-checked', value ? 'true' : 'false');
//         }


//         function setMode(newMode) {
//             mode = newMode;

//             modes.forEach(button => {
//                 const active = button.dataset.giftMode === mode;

//                 button.classList.toggle('active', active);
//                 button.setAttribute('aria-pressed', active ? 'true' : 'false');
//             });

//             if (mode === 'write') {
//                 if (textareaWrap) textareaWrap.hidden = false;

//                 if (help) {
//                     help.textContent =
//                         'Our team hand-letters your note inside the card before it ships.';
//                 }
//             } else {
//                 if (textareaWrap) textareaWrap.hidden = true;

//                 if (help) {
//                     help.textContent =
//                         "We'll tuck it in unwritten so you can fill it in yourself.";
//                 }
//             }
//         }


//         function updateCounter() {
//             if (counter && textarea) counter.textContent = textarea.value.length;
//         }


//         function removeGreetingCards() {
//             const variantIds = Array.from(cards).map(card =>
//                 Number(card.dataset.variantId)
//             );

//             return getCart().then(cart => {
//                 const matches = cart.items.filter(item =>
//                     variantIds.includes(item.variant_id)
//                 );

//                 return matches.reduce((promise, item) => {
//                     return promise.then(() =>
//                         post('/cart/change.js', {
//                             id: item.key,
//                             quantity: 0
//                         })
//                     );
//                 }, Promise.resolve());
//             });
//         }


//         function removeFee() {
//             if (!feeVariantId) return Promise.resolve();

//             return getCart().then(cart => {
//                 const matches = cart.items.filter(
//                     item => item.variant_id === feeVariantId
//                 );

//                 return matches.reduce((promise, item) => {
//                     return promise.then(() =>
//                         post('/cart/change.js', {
//                             id: item.key,
//                             quantity: 0
//                         })
//                     );
//                 }, Promise.resolve());
//             });
//         }


//         function addFee() {
//             if (!feeVariantId) return Promise.resolve();

//             return removeFee().then(() => {
//                 return post('/cart/add.js', {
//                     items: [{
//                         id: feeVariantId,
//                         quantity: 1,
//                         properties: {
//                             [NOTE_PROPERTY]: textarea ? textarea.value : ''
//                         }
//                     }]
//                 });
//             });
//         }


//         function saveNote() {
//             if (mode !== 'write' || !feeVariantId) return;

//             queue(() => {
//                 return getCart()
//                     .then(cart => {
//                         const line = cart.items.find(
//                             item => item.variant_id === feeVariantId
//                         );

//                         if (!line) {
//                             return addFee();
//                         }

//                         return post('/cart/change.js', {
//                             id: line.key,
//                             quantity: line.quantity || 1,
//                             properties: {
//                                 [NOTE_PROPERTY]: textarea ? textarea.value : ''
//                             }
//                         });
//                     })
//                     .then(refreshCart);
//             });
//         }


//         let noteTimer;

//         if (textarea) {
//             textarea.addEventListener('input', function () {
//                 if (textarea.value.length > NOTE_MAX) {
//                     textarea.value = textarea.value.slice(0, NOTE_MAX);
//                 }

//                 updateCounter();

//                 clearTimeout(noteTimer);
//                 noteTimer = setTimeout(saveNote, 600);
//             });
//         }


//         if (recipientToggle) {
//             recipientToggle.addEventListener('click', function () {
//                 const enabled =
//                     recipientToggle.getAttribute('aria-checked') !== 'true';

//                 setToggle(recipientToggle, enabled);
//                 if (recipientNote) recipientNote.hidden = !enabled;

//                 post('/cart/update.js', {
//                     attributes: {
//                         [RECIPIENT_ATTR]: enabled ? 'Yes' : 'No'
//                     }
//                 });
//             });
//         }


//         if (cardToggle) {
//             cardToggle.addEventListener('click', function () {
//                 const enabled =
//                     cardToggle.getAttribute('aria-checked') !== 'true';

//                 setToggle(cardToggle, enabled);
//                 if (expand) expand.hidden = !enabled;

//                 if (!enabled) {
//                     selectedCard = null;

//                     cards.forEach(card => {
//                         card.setAttribute('aria-checked', 'false');
//                     });

//                     if (textarea) textarea.value = '';
//                     updateCounter();

//                     setMode('blank');

//                     queue(() =>
//                         removeGreetingCards()
//                             .then(removeFee)
//                             .then(() =>
//                                 post('/cart/update.js', {
//                                     attributes: {
//                                         [MODE_ATTR]: 'blank'
//                                     }
//                                 })
//                             )
//                             .then(refreshCart)
//                     );
//                 }
//             });
//         }


//         cards.forEach(card => {
//             card.addEventListener('click', function () {
//                 const variantId = Number(card.dataset.variantId);

//                 if (!variantId || selectedCard === variantId) return;

//                 selectedCard = variantId;

//                 cards.forEach(item => {
//                     item.setAttribute(
//                         'aria-checked',
//                         item === card ? 'true' : 'false'
//                     );
//                 });

//                 queue(() =>
//                     removeGreetingCards()
//                         .then(() =>
//                             post('/cart/add.js', {
//                                 items: [{
//                                     id: variantId,
//                                     quantity: 1
//                                 }]
//                             })
//                         )
//                         .then(refreshCart)
//                 );
//             });
//         });


//         modes.forEach(button => {
//             button.addEventListener('click', function () {
//                 const newMode = button.dataset.giftMode;

//                 if (newMode === mode) return;

//                 setMode(newMode);

//                 queue(() => {
//                     return post('/cart/update.js', {
//                         attributes: {
//                             [MODE_ATTR]: newMode
//                         }
//                     })
//                     .then(() => {
//                         if (newMode === 'write') {
//                             return addFee();
//                         }

//                         return removeFee();
//                     })
//                     .then(refreshCart);
//                 });
//             });
//         });


//         // Restore existing cart state
//         getCart().then(cart => {
//             const attrs = cart.attributes || {};

//             const recipientEnabled =
//                 attrs[RECIPIENT_ATTR] === 'Yes';

//             if (recipientToggle) {
//                 setToggle(recipientToggle, recipientEnabled);
//                 if (recipientNote) recipientNote.hidden = !recipientEnabled;
//             }


//             const cardLine = cart.items.find(item => {
//                 return Array.from(cards).some(card =>
//                     Number(card.dataset.variantId) === item.variant_id
//                 );
//             });

//             if (cardLine) {
//                 selectedCard = cardLine.variant_id;

//                 if (cardToggle) setToggle(cardToggle, true);
//                 if (expand) expand.hidden = false;

//                 cards.forEach(card => {
//                     card.setAttribute(
//                         'aria-checked',
//                         Number(card.dataset.variantId) === selectedCard
//                             ? 'true'
//                             : 'false'
//                     );
//                 });
//             }


//             const feeLine = cart.items.find(
//                 item => item.variant_id === feeVariantId
//             );

//             if (feeLine) {
//                 if (cardToggle) setToggle(cardToggle, true);
//                 if (expand) expand.hidden = false;

//                 setMode('write');

//                 if (
//                     textarea &&
//                     feeLine.properties &&
//                     feeLine.properties[NOTE_PROPERTY]
//                 ) {
//                     textarea.value =
//                         feeLine.properties[NOTE_PROPERTY];
//                 }

//                 updateCounter();
//             } else {
//                 setMode('blank');
//             }
//         });
//     }


//     function initialize() {
//         document.querySelectorAll(SELECTOR).forEach(init);
//     }

//     initialize();

//     const observer = new MutationObserver(initialize);

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true
//     });

// })();


// /* ---------------------------------------------------------
//    Local Storage State Management & Auto-Reset on Empty Cart
// --------------------------------------------------------- */
// (function () {
//   const KEY = 'nmnl_gift_ui';
//   const restored = new WeakSet();

//   function load() {
//     try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
//     catch (e) { return {}; }
//   }

//   function save(patch) {
//     try {
//       localStorage.setItem(KEY, JSON.stringify(Object.assign(load(), patch)));
//     } catch (e) {}
//   }

//   function resetState() {
//     try {
//       localStorage.removeItem(KEY);
//     } catch (e) {}
//   }

//   function isOn(el) {
//     return !!el && el.getAttribute('aria-checked') === 'true';
//   }

//   function applyStateToUI(root, s) {
//     const mainBtn = root.querySelector('.cart-gift__main-toggle-btn');
//     const wrapper = root.querySelector('[data-gift-full-wrapper]');
//     const recipient = root.querySelector('[data-gift-recipient]');
//     const recipientNote = root.querySelector('[data-gift-recipient-note]');
//     const cardToggle = root.querySelector('[data-gift-card-toggle]');
//     const expand = root.querySelector('[data-gift-expand]');

//     // Main Toggle
//     const mainVal = (typeof s.main === 'boolean') ? s.main : false;
//     if (mainBtn && wrapper) {
//       mainBtn.setAttribute('aria-checked', mainVal ? 'true' : 'false');
//       wrapper.classList.toggle('is-open', mainVal);
//       wrapper.hidden = !mainVal;
//     }

//     // Ship to Recipient
//     const recVal = (typeof s.recipient === 'boolean') ? s.recipient : false;
//     if (recipient) {
//       recipient.setAttribute('aria-checked', recVal ? 'true' : 'false');
//       if (recipientNote) recipientNote.hidden = !recVal;
//     }

//     // Include Greeting Card
//     const cardVal = (typeof s.card === 'boolean') ? s.card : false;
//     if (cardToggle) {
//       cardToggle.setAttribute('aria-checked', cardVal ? 'true' : 'false');
//       if (expand) expand.hidden = !cardVal;
//     }
//   }

//   function restore(root) {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         // Cart-e jodi item na thake -> Reset storage & Turn OFF all toggles
//         if (cart.item_count === 0) {
//           resetState();
//           applyStateToUI(root, { main: false, recipient: false, card: false });
//         } else {
//           // Cart-e item thakle -> Load saved state (Reload dileo oivabe thakbe)
//           const s = load();
//           applyStateToUI(root, s);
//         }
//       })
//       .catch(() => {
//         const s = load();
//         applyStateToUI(root, s);
//       });
//   }

//   function restoreAll() {
//     document.querySelectorAll('[data-cart-gift]').forEach(restore);
//   }

//   // Click handle: State localStorage-e save hobe
//   document.addEventListener('click', function (e) {
//     const main = e.target.closest('.cart-gift__main-toggle-btn');
//     const rec = e.target.closest('[data-gift-recipient]');
//     const card = e.target.closest('[data-gift-card-toggle]');
//     if (!main && !rec && !card) return;

//     setTimeout(function () {
//       if (main) save({ main: isOn(main) });
//       if (rec) save({ recipient: isOn(rec) });
//       if (card) save({ card: isOn(card) });
//     }, 0);
//   }, true);

//   // Cart update/item remove hole auto check korbe cart empty kina
//   document.addEventListener('cart:updated', restoreAll);
//   document.addEventListener('cart:refresh', restoreAll);

//   new MutationObserver(restoreAll).observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   restoreAll();
//   document.addEventListener('DOMContentLoaded', restoreAll);
// })();






















(function () {
    const SELECTOR = '[data-cart-gift]';
    const NOTE_MAX = 200;

    const RECIPIENT_ATTR = 'Ship to recipient';
    const MODE_ATTR = 'gift_card_mode';
    const NOTE_PROPERTY = 'Gift Note';

    let writing = Promise.resolve();

    function post(url, data) {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Cart request failed: ${response.status}`);
            }

            return response.json();
        });
    }

    function refreshCart() {
        document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
        );
    }

    /* ---------------------------------------------------------
       NEW: Drawer er item list + footer + progress bar fresh kore.
       .cart-gift block touch kora hoy na, tai gift toggles
       (Make it a gift / Ship / Premium packaging) state thik thake.
    --------------------------------------------------------- */
    function swapNode(selector, doc) {
        var newNode = doc.querySelector(selector);
        var oldNode = document.querySelector(selector);

        if (newNode && oldNode) {
            oldNode.replaceWith(newNode);
        } else if (!newNode && oldNode) {
            // Notun HTML e nei (jemon threshold niche gele progress bar nei)
            oldNode.remove();
        }
    }

    function refreshCartItems() {
        return fetch(window.location.pathname + '?section_id=cart-drawer', {
            credentials: 'same-origin'
        })
            .then(function (r) { return r.text(); })
            .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');

                var newItems = doc.querySelector('#sidebar-cart .Cart__ItemList');
                var oldItems = document.querySelector('#sidebar-cart .Cart__ItemList');

                // Cart ekdom khali hoye gele (item list nei) -> puro content replace
                if (!newItems) {
                    var newContent = doc.querySelector('#sidebar-cart .Drawer__Content');
                    var oldContent = document.querySelector('#sidebar-cart .Drawer__Content');
                    if (newContent && oldContent) oldContent.replaceWith(newContent);
                } else {
                    // 1) Item list
                    if (oldItems) oldItems.replaceWith(newItems);

                    // 2) Progress bar (free shipping / free jewelry)
                    swapNode('#sidebar-cart .Cart__ProgressBar', doc);

                    // 3) Footer (total, savings)
                    var newFooter = doc.querySelector('#sidebar-cart .Drawer__Footer');
                    var oldFooter = document.querySelector('#sidebar-cart .Drawer__Footer');
                    if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);
                }

                // Cart dot + onnanno listener der janano
                document.dispatchEvent(
                    new CustomEvent('cart:updated', { bubbles: true })
                );
            })
            .catch(function () {});
    }

    function queue(task) {
        writing = writing
            .then(task)
            .catch(error => {
                console.error('[Cart Gift]', error);
            });

        return writing;
    }

    function getCart() {
        return fetch('/cart.js').then(response => response.json());
    }


    function init(root) {
        if (!root || root.dataset.giftInitialized === 'true') return;

        root.dataset.giftInitialized = 'true';

        const recipientToggle = root.querySelector('[data-gift-recipient]');
        const recipientNote = root.querySelector('[data-gift-recipient-note]');

        const cardToggle = root.querySelector('[data-gift-card-toggle]');
        const expand = root.querySelector('[data-gift-expand]');

        const cards = root.querySelectorAll('[data-gift-card]');
        const modes = root.querySelectorAll('[data-gift-mode]');

        const textareaWrap = root.querySelector('[data-gift-textarea]');
        const textarea = root.querySelector('[data-gift-note]');
        const counter = root.querySelector('[data-gift-count]');
        const help = root.querySelector('[data-gift-mode-help]');

        const feeVariantId = Number(root.dataset.handwritingVariant);

        let selectedCard = null;
        let mode = 'blank';


        function setToggle(toggle, value) {
            if (toggle) toggle.setAttribute('aria-checked', value ? 'true' : 'false');
        }


        function setMode(newMode) {
            mode = newMode;

            modes.forEach(button => {
                const active = button.dataset.giftMode === mode;

                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
            });

            if (mode === 'write') {
                if (textareaWrap) textareaWrap.hidden = false;

                if (help) {
                    help.textContent =
                        'Our team hand-letters your note inside the card before it ships.';
                }
            } else {
                if (textareaWrap) textareaWrap.hidden = true;

                if (help) {
                    help.textContent =
                        "We'll tuck it in unwritten so you can fill it in yourself.";
                }
            }
        }


        function updateCounter() {
            if (counter && textarea) counter.textContent = textarea.value.length;
        }


        // Shudhu 5ta greeting card variant remove kore, onno product na
        function removeGreetingCards() {
            const variantIds = Array.from(cards).map(card =>
                Number(card.dataset.variantId)
            );

            return getCart().then(cart => {
                const matches = cart.items.filter(item =>
                    variantIds.includes(item.variant_id)
                );

                return matches.reduce((promise, item) => {
                    return promise.then(() =>
                        post('/cart/change.js', {
                            id: item.key,
                            quantity: 0
                        })
                    );
                }, Promise.resolve());
            });
        }


        // Shudhu handwriting fee variant remove kore
        function removeFee() {
            if (!feeVariantId) return Promise.resolve();

            return getCart().then(cart => {
                const matches = cart.items.filter(
                    item => item.variant_id === feeVariantId
                );

                return matches.reduce((promise, item) => {
                    return promise.then(() =>
                        post('/cart/change.js', {
                            id: item.key,
                            quantity: 0
                        })
                    );
                }, Promise.resolve());
            });
        }


        function addFee() {
            if (!feeVariantId) return Promise.resolve();

            return removeFee().then(() => {
                return post('/cart/add.js', {
                    items: [{
                        id: feeVariantId,
                        quantity: 1,
                        properties: {
                            [NOTE_PROPERTY]: textarea ? textarea.value : ''
                        }
                    }]
                });
            });
        }


        function saveNote() {
            if (mode !== 'write' || !feeVariantId) return;

            queue(() => {
                return getCart()
                    .then(cart => {
                        const line = cart.items.find(
                            item => item.variant_id === feeVariantId
                        );

                        if (!line) {
                            return addFee();
                        }

                        return post('/cart/change.js', {
                            id: line.key,
                            quantity: line.quantity || 1,
                            properties: {
                                [NOTE_PROPERTY]: textarea ? textarea.value : ''
                            }
                        });
                    })
                    .then(refreshCartItems);
            });
        }


        let noteTimer;

        if (textarea) {
            textarea.addEventListener('input', function () {
                if (textarea.value.length > NOTE_MAX) {
                    textarea.value = textarea.value.slice(0, NOTE_MAX);
                }

                updateCounter();

                clearTimeout(noteTimer);
                noteTimer = setTimeout(saveNote, 600);
            });
        }


        if (recipientToggle) {
            recipientToggle.addEventListener('click', function () {
                const enabled =
                    recipientToggle.getAttribute('aria-checked') !== 'true';

                setToggle(recipientToggle, enabled);
                if (recipientNote) recipientNote.hidden = !enabled;

                post('/cart/update.js', {
                    attributes: {
                        [RECIPIENT_ATTR]: enabled ? 'Yes' : 'No'
                    }
                });
            });
        }


        if (cardToggle) {
            cardToggle.addEventListener('click', function () {
                const enabled =
                    cardToggle.getAttribute('aria-checked') !== 'true';

                setToggle(cardToggle, enabled);
                if (expand) expand.hidden = !enabled;

                if (!enabled) {
                    selectedCard = null;

                    cards.forEach(card => {
                        card.setAttribute('aria-checked', 'false');
                    });

                    if (textarea) textarea.value = '';
                    updateCounter();

                    setMode('blank');

                    // Greeting card + handwriting fee remove -> drawer refresh
                    queue(() =>
                        removeGreetingCards()
                            .then(removeFee)
                            .then(() =>
                                post('/cart/update.js', {
                                    attributes: {
                                        [MODE_ATTR]: 'blank'
                                    }
                                })
                            )
                            .then(refreshCartItems)
                    );
                }
            });
        }


        cards.forEach(card => {
            card.addEventListener('click', function () {
                const variantId = Number(card.dataset.variantId);

                if (!variantId || selectedCard === variantId) return;

                selectedCard = variantId;

                cards.forEach(item => {
                    item.setAttribute(
                        'aria-checked',
                        item === card ? 'true' : 'false'
                    );
                });

                queue(() =>
                    removeGreetingCards()
                        .then(() =>
                            post('/cart/add.js', {
                                items: [{
                                    id: variantId,
                                    quantity: 1
                                }]
                            })
                        )
                        .then(refreshCartItems)
                );
            });
        });


        modes.forEach(button => {
            button.addEventListener('click', function () {
                const newMode = button.dataset.giftMode;

                if (newMode === mode) return;

                setMode(newMode);

                queue(() => {
                    return post('/cart/update.js', {
                        attributes: {
                            [MODE_ATTR]: newMode
                        }
                    })
                    .then(() => {
                        if (newMode === 'write') {
                            return addFee();
                        }

                        return removeFee();
                    })
                    .then(refreshCartItems);
                });
            });
        });


        // Restore existing cart state
        getCart().then(cart => {
            const attrs = cart.attributes || {};

            const recipientEnabled =
                attrs[RECIPIENT_ATTR] === 'Yes';

            if (recipientToggle) {
                setToggle(recipientToggle, recipientEnabled);
                if (recipientNote) recipientNote.hidden = !recipientEnabled;
            }


            const cardLine = cart.items.find(item => {
                return Array.from(cards).some(card =>
                    Number(card.dataset.variantId) === item.variant_id
                );
            });

            if (cardLine) {
                selectedCard = cardLine.variant_id;

                if (cardToggle) setToggle(cardToggle, true);
                if (expand) expand.hidden = false;

                cards.forEach(card => {
                    card.setAttribute(
                        'aria-checked',
                        Number(card.dataset.variantId) === selectedCard
                            ? 'true'
                            : 'false'
                    );
                });
            }


            const feeLine = cart.items.find(
                item => item.variant_id === feeVariantId
            );

            if (feeLine) {
                if (cardToggle) setToggle(cardToggle, true);
                if (expand) expand.hidden = false;

                setMode('write');

                if (
                    textarea &&
                    feeLine.properties &&
                    feeLine.properties[NOTE_PROPERTY]
                ) {
                    textarea.value =
                        feeLine.properties[NOTE_PROPERTY];
                }

                updateCounter();
            } else {
                setMode('blank');
            }
        });
    }


    function initialize() {
        document.querySelectorAll(SELECTOR).forEach(init);
    }

    initialize();

    const observer = new MutationObserver(initialize);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();


/* ---------------------------------------------------------
   Local Storage State Management & Auto-Reset on Empty Cart
--------------------------------------------------------- */
(function () {
  const KEY = 'nmnl_gift_ui';
  const restored = new WeakSet();

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
    catch (e) { return {}; }
  }

  function save(patch) {
    try {
      localStorage.setItem(KEY, JSON.stringify(Object.assign(load(), patch)));
    } catch (e) {}
  }

  function resetState() {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function isOn(el) {
    return !!el && el.getAttribute('aria-checked') === 'true';
  }

  function applyStateToUI(root, s) {
    const mainBtn = root.querySelector('.cart-gift__main-toggle-btn');
    const wrapper = root.querySelector('[data-gift-full-wrapper]');
    const recipient = root.querySelector('[data-gift-recipient]');
    const recipientNote = root.querySelector('[data-gift-recipient-note]');
    const cardToggle = root.querySelector('[data-gift-card-toggle]');
    const expand = root.querySelector('[data-gift-expand]');

    // Main Toggle
    const mainVal = (typeof s.main === 'boolean') ? s.main : false;
    if (mainBtn && wrapper) {
      mainBtn.setAttribute('aria-checked', mainVal ? 'true' : 'false');
      wrapper.classList.toggle('is-open', mainVal);
      wrapper.hidden = !mainVal;
    }

    // Ship to Recipient
    const recVal = (typeof s.recipient === 'boolean') ? s.recipient : false;
    if (recipient) {
      recipient.setAttribute('aria-checked', recVal ? 'true' : 'false');
      if (recipientNote) recipientNote.hidden = !recVal;
    }

    // Include Greeting Card
    const cardVal = (typeof s.card === 'boolean') ? s.card : false;
    if (cardToggle) {
      cardToggle.setAttribute('aria-checked', cardVal ? 'true' : 'false');
      if (expand) expand.hidden = !cardVal;
    }
  }

  function restore(root) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Cart-e jodi item na thake -> Reset storage & Turn OFF all toggles
        if (cart.item_count === 0) {
          resetState();
          applyStateToUI(root, { main: false, recipient: false, card: false });
        } else {
          // Cart-e item thakle -> Load saved state (Reload dileo oivabe thakbe)
          const s = load();
          applyStateToUI(root, s);
        }
      })
      .catch(() => {
        const s = load();
        applyStateToUI(root, s);
      });
  }

  function restoreAll() {
    document.querySelectorAll('[data-cart-gift]').forEach(restore);
  }

  // Click handle: State localStorage-e save hobe
  document.addEventListener('click', function (e) {
    const main = e.target.closest('.cart-gift__main-toggle-btn');
    const rec = e.target.closest('[data-gift-recipient]');
    const card = e.target.closest('[data-gift-card-toggle]');
    if (!main && !rec && !card) return;

    setTimeout(function () {
      if (main) save({ main: isOn(main) });
      if (rec) save({ recipient: isOn(rec) });
      if (card) save({ card: isOn(card) });
    }, 0);
  }, true);

  // Cart update/item remove hole auto check korbe cart empty kina
  document.addEventListener('cart:updated', restoreAll);
  document.addEventListener('cart:refresh', restoreAll);

  new MutationObserver(restoreAll).observe(document.body, {
    childList: true,
    subtree: true
  });

  restoreAll();
  document.addEventListener('DOMContentLoaded', restoreAll);
})();